import { render, staticRenderFns } from "./CaptureLicenseFront.vue?vue&type=template&id=735145c8&scoped=true&"
import script from "./CaptureLicenseFront.vue?vue&type=script&lang=ts&"
export * from "./CaptureLicenseFront.vue?vue&type=script&lang=ts&"
import style0 from "./CaptureLicenseFront.vue?vue&type=style&index=0&id=735145c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735145c8",
  null
  
)

export default component.exports